/* GlideHome «назад»: возврат на предыдущую страницу ровно в то место, откуда был переход.

   Подключён на всех страницах из layout/theme.liquid обычным <script> в конце body (не defer):
   успевает до первой отрисовки и раньше модулей Horizon, которые тоже трогают историю.

   Как устроено:
   - у каждой записи истории браузера свой id (history.state.glideId); снимок записи лежит в
     sessionStorage: адрес, имя страницы (meta glide-page), откуда пришли, прокрутка и «якорь» -
     нажатая ссылка или секция у верхнего края экрана;
   - снимок пишется при клике по ссылке, перед pushState и на pagehide;
   - кнопка браузера «назад»/«вперёд», перезагрузка и кнопка сайта [data-glide-back]
     ставят нажатую ссылку на то же место экрана. Пока догружаются картинки, позиция
     подправляется - до первого касания, колеса или клавиши, либо 1.5 с после load;
   - прокрутку ведём сами (scrollRestoration = manual): на компьютере Horizon крутит не окно,
     а .page-wrapper, и родное восстановление браузера туда не попадает.
   Кнопка сайта уходит через history.go - это тот же «назад» браузера, страница часто
   поднимается из bfcache мгновенно. Если запись не соседняя (вкладка открыта с нуля),
   переходит по адресу и просит восстановить прокрутку через glide:want. */
(function () {
  'use strict';
  var ss;
  try { ss = window.sessionStorage; ss.getItem('glide:h'); } catch (e) { return; }
  if (!ss || !window.history || !history.replaceState || !document.addEventListener) return;

  var KEY = 'glide:h';      // { e: {id: запись}, o: [id в порядке создания], cur: id показанной записи }
  var WANT = 'glide:want';  // кнопка сайта ушла по адресу, а не по истории: чью прокрутку вернуть
  var MAX = 40;             // глубже назад не ходят, память не копим
  var SQUEEZE = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  var origPush = history.pushState, origReplace = history.replaceState;

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  /* Horizon при повороте экрана через 990px возвращает auto - держим manual */
  if (SQUEEZE && SQUEEZE.addEventListener) {
    SQUEEZE.addEventListener('change', function () { setTimeout(function () { history.scrollRestoration = 'manual'; }, 0); });
  }

  function read(k) { try { return JSON.parse(ss.getItem(k) || 'null'); } catch (e) { return null; } }
  function load() { var d = read(KEY); return (d && d.e && d.o) ? d : { e: {}, o: [] }; }
  var db = load();
  function save() {
    while (db.o.length > MAX) delete db.e[db.o.shift()];
    try { ss.setItem(KEY, JSON.stringify(db)); } catch (e) {}
  }

  function here() { return location.pathname + location.search; }
  /* одна и та же страница: #якоря и подгрузка ?page=2 - не повод возвращаться */
  function pageKey(u) {
    var p;
    try { p = new URL(u, location.href); } catch (e) { return u; }
    return p.pathname + '?' + (p.searchParams.get('q') || '');
  }
  function stateObj() { var s = history.state; return (s && typeof s === 'object') ? s : {}; }
  function stamp(id) {
    var s = stateObj(), n = {};
    if (s.glideId === id) return;
    for (var k in s) n[k] = s[k];
    n.glideId = id;
    try { origReplace.call(history, n, ''); } catch (e) {}
  }
  function pageName() {
    var m = document.querySelector('meta[name="glide-page"]');
    return (m && m.getAttribute('content')) || document.title || 'Back';
  }
  /* now - сразу записать id в историю. При открытии страницы - нет: replaceState до первого
     клика обрывает анимацию следующего перехода (cross-document View Transitions Horizon,
     проверено в Chrome 151 - и сразу при загрузке, и после pagereveal). Поэтому id попадает
     в историю при уходе со страницы (remember: клик, pushState, pagehide) - как scrollTop у
     самого Horizon; если браузер его не сохранил, запись находится по адресу (byUrl) */
  function add(parent, adj, now) {
    var nid = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    db.e[nid] = { u: here(), n: pageName(), p: (parent && db.e[parent]) ? parent : null, adj: !!adj };
    db.o.push(nid);
    if (now) stamp(nid);
    return nid;
  }
  function byUrl(u) {
    for (var i = db.o.length - 1; i >= 0; i--) { if (db.e[db.o[i]] && db.e[db.o[i]].u === u) return db.o[i]; }
    return null;
  }

  /* ---------- снимок: где стоим и что нажали ---------- */
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (SQUEEZE && SQUEEZE.matches && pw) {
      var o = getComputedStyle(pw).overflowY;
      if (o === 'auto' || o === 'scroll') return pw;
    }
    return document.scrollingElement || document.documentElement;
  }
  /* ссылка едет вместе со страницей: не шапка, не выпадающее меню, не фиксированная панель.
     Иначе после возврата она стоит на прежнем месте экрана при любой прокрутке */
  function moving(el) {
    for (var n = el; n && n !== document.body; n = n.parentElement) {
      if (n.id === 'header-group' || n.tagName === 'DIALOG') return false;
      var p = getComputedStyle(n).position;
      if (p === 'fixed' || p === 'sticky') return false;
    }
    return !!el.isConnected;
  }
  function sameHref(scope, href) {
    var out = [], list = scope.getElementsByTagName('a');
    for (var i = 0; i < list.length; i++) { if (list[i].getAttribute('href') === href) out.push(list[i]); }
    return out;
  }
  function snap(link) {
    var sc = scroller(), r = { y: Math.round(sc.scrollTop), h: sc.scrollHeight };
    var secs = document.querySelectorAll('#MainContent > .shopify-section, footer .shopify-section');
    for (var i = 0; i < secs.length; i++) {
      var b = secs[i].getBoundingClientRect();
      if (b.height > 0 && b.bottom > 1) { r.s = { id: secs[i].id, off: Math.round(-b.top) }; break; }
    }
    if (link && moving(link)) {
      var rect = link.getBoundingClientRect();
      var sec = link.closest('.shopify-section'), href = link.getAttribute('href');
      if ((rect.width || rect.height) && href) {
        r.a = { sec: sec ? sec.id : '', href: href, i: sameHref(sec || document, href).indexOf(link), top: Math.round(rect.top) };
      }
    }
    return r;
  }
  var id;
  function remember(link) {
    var e = db.e[id];
    if (!e) return;
    stamp(id);
    var s = snap(link);
    /* pagehide сразу за кликом: прокрутка та же - якорь-ссылку из клика не теряем */
    if (!link && e.a && Math.abs(s.y - (e.y || 0)) < 5) s.a = e.a;
    e.y = s.y; e.h = s.h; e.s = s.s; e.a = s.a; e.u = here();
    save();
  }

  /* ---------- восстановление ---------- */
  function find(a) {
    var scope = (a.sec && document.getElementById(a.sec)) || document;
    return sameHref(scope, a.href)[a.i] || null;
  }
  function targetOf(e, sc) {
    if (e.a) {
      var el = find(e.a);
      if (el && moving(el)) {
        var r = el.getBoundingClientRect();
        if (r.width || r.height) return sc.scrollTop + r.top - e.a.top;
      }
    }
    if (e.s) {
      var sec = document.getElementById(e.s.id);
      if (sec && sec.getBoundingClientRect().height) return sc.scrollTop + sec.getBoundingClientRect().top + e.s.off;
    }
    return e.y || 0;
  }
  function jump(sc, y) {
    /* instant: у .page-wrapper в Horizon scroll-behavior: smooth */
    try { sc.scrollTo({ top: y, behavior: 'instant' }); } catch (x) { sc.scrollTop = y; }
  }
  var stopRestore = null;
  function restore(e) {
    if (stopRestore) stopRestore();
    if (!e || !(e.y > 0 || e.a || e.s)) return;
    var sc = scroller(), spacer = null, done = false, loadedAt = 0, t0 = Date.now();
    var root = (sc === document.scrollingElement || sc === document.documentElement) ? document.body : sc;
    /* пока картинки не догрузились, страница короче нужной точки и прокручивать некуда -
       резервируем высоту прокладкой в конце, потом убираем */
    function fit() {
      var need = (e.h || 0) - (sc.scrollHeight - (spacer ? spacer.offsetHeight : 0));
      if (need > 0 && !spacer) {
        spacer = document.createElement('div');
        spacer.setAttribute('aria-hidden', 'true');
        spacer.style.cssText = 'height:0;margin:0;padding:0;pointer-events:none';
        root.appendChild(spacer);
      }
      if (spacer) spacer.style.height = Math.max(0, need) + 'px';
    }
    function step() {
      if (done) return;
      fit();
      var y = Math.max(0, Math.round(targetOf(e, sc)));
      if (Math.abs(sc.scrollTop - y) > 1) jump(sc, y);
      if ((loadedAt && Date.now() - loadedAt > 1500) || Date.now() - t0 > 8000) stop();
    }
    function onLoad() { loadedAt = Date.now(); step(); }
    var evs = ['wheel', 'touchstart', 'mousedown', 'keydown'];
    function stop() {
      if (done) return;
      done = true;
      clearInterval(timer);
      if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
      evs.forEach(function (n) { window.removeEventListener(n, stop, true); });
      window.removeEventListener('load', onLoad);
      stopRestore = null;
    }
    /* человек сам взялся за прокрутку - больше не двигаем */
    evs.forEach(function (n) { window.addEventListener(n, stop, { capture: true, passive: true }); });
    if (document.readyState === 'complete') loadedAt = t0;
    else window.addEventListener('load', onLoad);
    var timer = setInterval(step, 50);
    stopRestore = stop;
    step();
  }

  /* ---------- кнопка сайта «назад» ---------- */
  /* ближайшая запись другой страницы вверх по цепочке и сколько шагов истории до неё */
  function prevPage() {
    var e = db.e[id], steps = 0, adj = true, me = pageKey(here());
    while (e && e.p && db.e[e.p]) {
      adj = adj && e.adj;
      steps++;
      var pid = e.p;
      e = db.e[pid];
      if (pageKey(e.u) !== me) return { id: pid, e: e, steps: steps, adj: adj };
    }
    return null;
  }
  function wire() {
    var t = prevPage();
    if (!t) return;  // пришли на сайт сразу сюда - остаётся запасной адрес из Liquid
    var links = document.querySelectorAll('[data-glide-back]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', t.e.u);
      var label = links[i].querySelector('[data-glide-back-label]');
      if (label && t.e.n) label.textContent = t.e.n;
    }
  }
  function goBack(ev, link) {
    var t = prevPage();
    if (!t) { remember(link); return; }  // предыдущей страницы нет - обычный переход по запасному адресу
    ev.preventDefault();
    remember(null);
    function byAddress() {
      try { ss.setItem(WANT, JSON.stringify({ id: t.id })); } catch (x) {}
      location.href = t.e.u;
    }
    if (t.adj && history.length > t.steps) {
      var left = false;
      window.addEventListener('pagehide', function () { left = true; });
      history.go(-t.steps);
      /* история не сработала (такое бывает во встроенных браузерах) - идём по адресу */
      setTimeout(function () { if (!left && document.visibilityState === 'visible' && pageKey(here()) !== pageKey(t.e.u)) byAddress(); }, 2500);
    } else {
      byAddress();
    }
  }

  /* ---------- какая это запись истории ---------- */
  function sameOriginReferrer() {
    try { var r = new URL(document.referrer); return r.origin === location.origin ? r.pathname : null; } catch (e) { return null; }
  }
  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
  var navType = nav.type || ((performance.navigation && performance.navigation.type === 2) ? 'back_forward' : 'navigate');
  var want = read(WANT);
  try { ss.removeItem(WANT); } catch (e) {}
  var restoreFrom = null;

  id = stateObj().glideId;
  if (!(id && db.e[id]) && navType === 'back_forward') id = byUrl(here());  // чужой replaceState стёр id
  if (id && db.e[id]) {
    /* та же запись: «назад»/«вперёд» браузера или перезагрузка */
    db.e[id].u = here();
    if (navType === 'back_forward' || navType === 'reload') restoreFrom = db.e[id];
  } else if (want && db.e[want.id] && pageKey(db.e[want.id].u) === pageKey(here())) {
    /* кнопка сайта привела по адресу: новая запись встаёт на место прежней - тот же родитель */
    var w = db.e[want.id];
    id = add(w.p, false);
    ['y', 'h', 's', 'a'].forEach(function (k) { if (w[k] !== undefined) db.e[id][k] = w[k]; });
    restoreFrom = w;
  } else {
    /* обычный переход: родитель - страница, с которой ушли, если пришли с нашего сайта.
       Соседняя запись в истории - если браузер пришёл именно с неё */
    var ref = sameOriginReferrer(), cur = db.cur && db.e[db.cur] ? db.cur : null;
    var parent = (ref !== null) ? cur : null;
    var adj = !!(parent && ref === new URL(db.e[parent].u, location.href).pathname && history.length > 1);
    id = add(parent, adj);
  }
  db.cur = id;
  save();

  /* ---------- события ---------- */
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target : null;
    var a = t ? t.closest('a[href]') : null;
    if (!a) {
      /* карточка Horizon уходит на товар скриптом (клик по фото-галерее мимо ссылки) -
         якорем берём ссылку самой карточки */
      var card = t ? t.closest('product-card') : null;
      if (card && card.querySelector('a[href]')) remember(card.querySelector('a[href]'));
      return;
    }
    if (a.hasAttribute('data-glide-back') && !ev.metaKey && !ev.ctrlKey && !ev.shiftKey && ev.button === 0) { goBack(ev, a); return; }
    remember(a);
  }, true);

  window.addEventListener('pagehide', function () { remember(null); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') remember(null); });

  /* страница поднята из bfcache: прокрутка цела, но память могла уйти вперёд */
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    db = load();
    if (!db.e[id]) id = add(null, false, true);
    db.cur = id;
    save();
    wire();
  });

  /* фильтры и подгрузка страниц Horizon делают pushState - это новая запись того же документа */
  history.pushState = function () {
    remember(null);
    var r = origPush.apply(history, arguments);
    id = add(id, true, true);
    db.cur = id;
    save();
    return r;
  };
  /* чужой replaceState({}) стирает наш id - возвращаем его, адрес записи обновляем */
  history.replaceState = function () {
    var r = origReplace.apply(history, arguments);
    stamp(id);
    if (db.e[id]) { db.e[id].u = here(); save(); }
    return r;
  };

  /* переход по #якорю и обратно - внутри той же страницы */
  function sync() {
    db = load();
    var s = stateObj(), nid = s.glideId;
    if (nid && db.e[nid]) {
      if (nid === id) return;
      id = nid;
      /* у фильтров Horizon своя прокрутка (state.scrollTop) - не мешаем */
      if (typeof s.scrollTop !== 'number') restore(db.e[id]);
    } else {
      id = add(id, true, true);
    }
    db.cur = id;
    save();
    wire();
  }
  window.addEventListener('popstate', sync);
  window.addEventListener('hashchange', sync);

  if (restoreFrom) restore(restoreFrom);
  else if (location.hash.length > 1) landOnHash();
  wire();

  /* переход с другой страницы по ссылке с #якорем (Products в шапке -> /#glide-categories).
     Браузер прокручивает к якорю сам, плавно; если анимация смены страниц (View Transitions
     Horizon) ему помешала и прокрутка стоит - после load ставим блок под шапку
     (scroll-margin-top). Не scrollIntoView: он двигает и корень документа, который на компьютере
     прокручиваться не должен, - блок уезжает под шапку. Человек уже листает сам - не трогаем */
  function landOnHash() {
    var touched = false;
    var mark = function () { touched = true; };
    ['wheel', 'touchstart', 'mousedown', 'keydown'].forEach(function (n) { window.addEventListener(n, mark, { capture: true, passive: true, once: true }); });
    window.addEventListener('load', function () {
      var sc = scroller(), last = -1, tries = 0;
      (function check() {
        var t = null;
        try { t = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (e) {}
        if (!t || touched) return;
        var gap = t.getBoundingClientRect().top - (parseFloat(getComputedStyle(t).scrollMarginTop) || 0);
        if (Math.abs(gap) < 40) return;
        /* браузер ещё едет к якорю - ждём, пока остановится */
        if (sc.scrollTop !== last && tries++ < 8) { last = sc.scrollTop; setTimeout(check, 250); return; }
        jump(sc, Math.round(sc.scrollTop + gap));
      })();
    });
  }
})();
